import{B as s,D as o}from"./prod-ssr.js";const a=s,t=o;export{a as b,t as d};
//# sourceMappingURL=index5.js.map
